import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

/** @alpha */
export const announcementsTranslationRef = createTranslationRef({
    id: 'announcements',
    messages: {
        page: {
            title: 'Announcements Page',
            description: 'View announcements',
        },
        admin: {
            title: 'Announcements Administration',
            description: 'Create, edit and manage announcements',
        },
        alerts: {
            loading: 'Loading announcements...',
            errorLoading: 'Error loading announcements',
            createdSuccessfully: 'Announcement created successfully',
            errorCreating: 'Error creating announcement',
            updatedSuccessfully: 'Announcement updated successfully',
            errorUpdating: 'Error updating announcement',
            deletedSuccessfully: 'Announcement deleted successfully',
            errorDeleting: 'Error deleting announcement',
            noAnnouncements: 'No announcements found',
            accessDeniedTitle: 'Access Denied',
            accessDenied: 'You do not have permission to access this page. Only platform administrators can manage announcements.',
        },
        button: {
            newAnnouncement: 'New Announcement',
            save: 'Save',
            cancel: 'Cancel',
            clearFilters: 'Clear Filters',
            viewAll: 'View All',
            close: 'Close',
        },
        table: {
            title: 'Announcements',
            columns: {
                title: 'Title',
                message: 'Message',
                publisher: 'Publisher',
                category: 'Category',
                severity: 'Severity',
                tags: 'Tags',
                created: 'Created',
                start: 'Start',
                until: 'Until',
                actions: 'Actions',
            },
            active: 'Active',
            inactive: 'Inactive',
        },
        dialog: {
            createTitle: 'Create Announcement',
            editTitle: 'Edit Announcement',
            fields: {
                title: 'Title',
                message: 'Message',
                severity: {
                    title: 'Severity',
                    success: 'Success',
                    info: 'Info',
                    warning: 'Warning',
                    error: 'Error',
                },
                category: 'Category',
                tags: 'Tags (comma separated)',
                startDate: 'Start Date',
                endDate: 'End Date',
                active: 'Active',
            }
        },
        filters: {
            title: 'Filters',
            search: 'Search announcements',
            category: 'Select a Category',
            tags: 'Select Tags',
            created: 'Created After',
            startDate: 'Start After',
            endDate: 'End Before',
            activeOn: 'Active On',
            createdFrom: 'Created From',
            createdTo: 'Created To',
        },
        popup: {
            dialog: {
                title: 'Important Announcements',
                from: 'From',
                until: 'Until',
            }
        }
    },
});